import React from "react";
import { Form, Input, Button } from "antd";
import { LockOutlined, StopOutlined, SaveOutlined } from "@ant-design/icons";
import {
  CONFIRMPASSWORD_VALIDATOR,
  CREATEPASSWORD_VALIDATOR,
  owntoast,
} from "../../utils/index";
import * as Components from "../../components";

function Modals(props) {
  const [form] = Form.useForm();
  let data = JSON.parse(localStorage.getItem("editRow"));
  const formSubmit = (e) => {
    if (e.oldpassword !== e.confirmpassword) {
      let tmp = {
        id: data.id,
        pass: e.confirmpassword,
      };
      props
        .request({
          url: `/user/changepass`,
          method: "POST",
          body: tmp,
        })
        .then((res) => {
          if (res.success) {
            owntoast(res.message, "success");
            form.resetFields();
            props.onClose(true);
          } else {
            owntoast(res.message, "error");
          }
        });
    } else {
      owntoast("Хуучин нууц үг дахин оруулах боломжгүй", "error");
    }
  };

  return (
    <Components.GlobalModal
      title="Нууц үг сэргээх"
      isOpen={props.isOpen ? true : false}
      onClose={() => props.onClose(true)}
      footer={null}
      width={600}
    >
      <Form
        onFinish={formSubmit}
        className="p-4"
        form={form}
        initialValues={{
          phone: data && data.name,
        }}
      >
        <div>
          <Form.Item label="Нэвтрэх нэр" name="phone">
            <Input disabled style={{ width: 350, float: "right" }} />
          </Form.Item>
          <Form.Item
            label="Шинэ нууц үг"
            name="password"
            rules={CREATEPASSWORD_VALIDATOR}
          >
            <Input.Password
              style={{ width: 350, float: "right" }}
              placeholder="Шинэ нууц үг"
              prefix={<LockOutlined />}
            />
          </Form.Item>
          <Form.Item
            label="Шинэ нууц үг (давтах)"
            name="confirmpassword"
            rules={CONFIRMPASSWORD_VALIDATOR}
          >
            <Input.Password
              style={{ width: 350, float: "right" }}
              placeholder="Шинэ нууц үг (давтах)"
              prefix={<LockOutlined />}
            />
          </Form.Item>
        </div>
        <div
          style={{
            justifyContent: "end",
            display: "flex",
            width: "100%",
            marginRight: 15,
          }}
        >
          <Button
            icon={<StopOutlined />}
            onClick={() => props.onClose(true)}
            style={{ backgroundColor: "#595959", color: "white" }}
          >
            Болих
          </Button>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            htmlType="submit"
            style={{ marginLeft: 5 }}
          >
            Хадгалах
          </Button>
        </div>
      </Form>
    </Components.GlobalModal>
  );
}
export default Modals;
